import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function PainSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const lines = ['Leíste los libros.', 'Seguiste las cuentas correctas.', 'Viste los videos motivacionales a las 5 AM.', 'Prometiste que este año era diferente.', 'Y sin embargo…'];
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-bg)'
  }} data-id="element-273">
      <div className="max-w-2xl mx-auto" data-id="element-274">
        {/* Staggered lines */}
        <div className="space-y-4 mb-12" data-id="element-275">
          {lines.map((line, i) => <motion.p key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: i * 0.15,
          duration: 0.6,
          ease: 'easeOut'
        }} className={`text-2xl md:text-3xl font-medium leading-snug ${line === 'Y sin embargo…' ? 'italic' : ''}`} style={{
          fontFamily: 'Playfair Display, serif',
          color: line === 'Y sin embargo…' ? 'var(--color-accent)' : 'var(--color-text)'
        }} data-id="element-276">
              {line}
            </motion.p>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.9,
        duration: 0.7
      }} data-id="element-277">
          <p className="text-3xl md:text-4xl font-black mb-10" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-278">
            Aquí estás.
          </p>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-279">
            Buscando otra cosa que finalmente te mueva.
          </p>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-280">
            No te estoy juzgando.
          </p>

          <p className="text-xl font-semibold mb-10" style={{
          color: 'var(--color-text)'
        }} data-id="element-281">
            Te estoy describiendo.
          </p>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-282">
            Porque eso no es falta de ganas. No es falta de fe. No es pereza
            disfrazada de espiritualidad.
          </p>

          <p className="text-xl font-bold mb-10" style={{
          color: 'var(--color-text)'
        }} data-id="element-283">
            Es algo más profundo. Algo que la industria del crecimiento personal
            nunca te va a decir — porque si lo dijera, perdería su negocio.
          </p>

          {/* Blockquote */}
          <div className="py-6 px-8 my-10 rounded-sm" style={{
          borderLeft: '4px solid var(--color-accent)',
          background: 'var(--color-surface)'
        }} data-id="element-284">
            <p className="text-xl md:text-2xl italic leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-text)'
          }} data-id="element-285">
              "No puedes crecer hacia afuera más de lo que has crecido hacia
              adentro."
            </p>
          </div>

          <p className="text-lg leading-relaxed" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-286">
            Y el contenido que consumes todos los días — los podcasts, los
            reels, los libros de autoayuda — está diseñado para hacer una sola
            cosa:{' '}
            <strong style={{
            color: 'var(--color-text)'
          }} data-id="element-287">
              mantenerte enganchado. No transformado.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}